import InfinitScroll from 'components/infinitScrol'
import React from 'react'
import { InfiniteData } from 'react-query'
import Item from './item'
interface ILoansProps {
    data: InfiniteData<IGetFinancialLoans>
    onWatchEnd: () => void
}
export default function Loans({ data, onWatchEnd }: ILoansProps) {
    return (
        <InfinitScroll onWatchEnd={onWatchEnd}>
            <div>
                {data.pages
                    .flatMap((x) => x.results)
                    .map((item) => (
                        <Item
                            item={item}
                            key={item.id}
                            name={item.poolship_name}
                        />
                    ))}
            </div>
        </InfinitScroll>
    )
}
